import _ from 'lodash';
import './../sass/main.scss';


window.$ = window.jQuery = require('jquery');
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

require('./typographer/jquery.typographer.min.pack.js');
require('./typographer/hyph-pl.min.js');

require('../../../node_modules/lightbox2/dist/js/lightbox');
require('../../../node_modules/owl.carousel/dist/owl.carousel');
require('../../../node_modules/jquery-ui/dist/jquery-ui.min');
// require('../../../node_modules/fotorama/fotorama');
require('../../../node_modules/justifiedGallery/dist/js/jquery.justifiedGallery.min');
//const simpleParallax = require('../../../node_modules/simple-parallax-js');
require('./jquery.paroller');


import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from './lightgallery/plugins/zoom';
import {YouTubeEmbed} from "./YoutubeVideo";

jQuery.noConflict();
YouTubeEmbed();

function sortujRozmiary(rozmiary) {
    rozmiary = rozmiary.sort(function (a, b) {
        return parseInt(a.Wymiar.Wyso) - parseInt(b.Wymiar.Wyso);
    });
    rozmiary = rozmiary.sort(function (a, b) {
        return parseInt(a.Wymiar.Szer) - parseInt(b.Wymiar.Szer);
    });
    return rozmiary;
}

window.productDetails = function (productId, productCategory) {
    window.kartaProduktu = false;
    //ustalWarianty();
    window.wariantyProduktu = [];
    let prod, warianty = [];
    for (let i in lustra) {
        if (lustra[i].Id == productId) {
            window.kartaProduktu = lustra[i];
            break;
        }
    }

    let zgrupowane = lustraWgKategoriiWGrupach();
    let items = zgrupowane[productCategory];

    rozmiaryLoop1:
        for (let i in items) {
            let rozmiary = sortujRozmiary(items[i]);
            rozmiaryLoop2:
                for (let j in rozmiary) {
                    if (rozmiary[j].Id == productId) {
                        window.kartaProduktu['rozmiary'] = rozmiary;
                        break rozmiaryLoop1;
                    }
                }
        }

    if (window.kartaProduktu) {
        for (let j in window.kartaProduktu['Warianty lustra']) {
            warianty.push(j);
        }
        if (warianty.length > 0) {
            for (let k in lustra) {
                if (warianty.includes(lustra[k].Id)) {
                    window.wariantyProduktu.push(lustra[k]);
                }
            }
        }
    }
}

window.categoryProducts = function (category, type = 'category') {
    // let allProducts = lustraWgKategorii2Luty();

    let allProducts

    if (type === 'collection') {

        allProducts = kolekcje();
    } else {
        allProducts = lustraWgKategoriiWGrupach();
    }


    window.categoryProductsData = allProducts[category];
}

window.newProducts = function (count) {
    let noweLustra = lustraNowości().filter((x, n) => n < count);
    window.newProductsData = [];
    for (let i in noweLustra) {
        window.newProductsData.push(noweLustra[i].lustra);
    }
}

let topNavbar;
let body;
let megamenu;
jQuery(document).ready(function () {
    body = jQuery('body');
    topNavbar = jQuery('#navbar');
    megamenu = jQuery('div.megamenu');
    jQuery('body img').addClass('img-fluid');

    jQuery('body').typographer_orphan({
        forbidden: ["a", "i", "o", "u", "w", "z", "oraz", "dla"]
    });

    jQuery('.carousel-indicators>button').on('mouseover', function () {
        jQuery(this).trigger('click');
    });

    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl)
    });

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    });

    jQuery('.wrap-wysiwyg table, .wysiwyg-content table, .wysiwyg-download table').addClass('table').wrap('<div class="table-responsive"></div>');
    jQuery('.wysiwyg-subpage table').addClass('table table-borderless').wrap('<div class="table-responsive"></div>');

    if (!(typeof offerId == "undefined") && !(offerId == null)) {
        jQuery('.wrap-wysiwyg img').each(function () {
            let thImg = jQuery(this);
            thImg.attr('src', window.baseUrl + '/storage/media_offers/' + offerId + '-content/' + thImg.attr('src'));
        });
    }

    mainResize();

    if (typeof window.initProductGallery == 'function')
        window.initProductGallery();


    jQuery(function () {
        jQuery.widget('custom.catcomplete', jQuery.ui.autocomplete, {
            _create: function () {
                this._super();
                this.widget().menu('option', 'items', '> :not(.ui-autocomplete-category)');
            },
            _renderItem: function (ul, item) {
                let link = jQuery('<a/>').text(item.title).attr('href', item.url);
                link.click(function (evt) {
                    jQuery('#main-loader').show();
                });
                return jQuery("<li>")
                    .append(link)
                    .appendTo(ul);
            },
            _renderMenu: function (ul, items) {
                let that = this,
                    currentCategory = '';
                jQuery.each(items, function (index, item) {
                    let li;
                    if (item.category != currentCategory) {
                        ul.append('<li class="ui-autocomplete-category">' + item.category + '</li>');
                        currentCategory = item.category;
                    }
                    li = that._renderItemData(ul, item);
                    if (item.category) {
                        li.attr('aria-label', item.category + ' : ' + item.title);
                    }
                });
            }
        });

        jQuery("#search").catcomplete({
            delay: 0,
            source: window.searchData,
            select: function (event, ui) {
                jQuery('#main-loader').show();
                document.location.href = ui.item.url;
            }
        });
    });
    jQuery('.top-search-btn').on('click', function (evt) {
        evt.preventDefault();
        jQuery('#topSearch').slideToggle();
        jQuery('input#search').focus();
    });

    /*jQuery('.bottom-more-link').on('click', function() {
        // if(jQuery(this).text() == 'rozwiń') {
        //     jQuery(this).text('zwiń');
        // } else {
        //     jQuery(this).text('rozwiń');
        // }
        jQuery(this).hide();
        jQuery(this).prev('.bottom-shadow-more').hide();
        jQuery(this).prev('.bottom-shadow-more').prev('.more-wrap').toggleClass('expanded');
    });*/

    /**
     * Bootstrap Carousels
     */
    document.querySelectorAll(".box-thumbs.carousel").forEach(function (el) {
        let autoplay = el.classList.contains("autoplay");
        let carousel = new bootstrap.Carousel(el, {
            interval: autoplay && 3000,
            ride: autoplay && 'carousel',
            touch: true,
        });
        if (autoplay && carousel) {
            carousel.cycle();
        }
    });

    jQuery('.paroller').paroller();
    jQuery(".lightbox-gallery").justifiedGallery({
        rowHeight: 200,
        margins: 2
    });

    jQuery('.g-recaptcha').on('mouseover', function (e) {
        recaptchaCallbackForm = jQuery(this).closest('form');
    });
});

window.onload = function () {
    let renderProductsList = function (categoryProducts, elementID) {

        if (categoryProducts.length > 0) {
            for (let i in categoryProducts) {
                let products = categoryProducts[i];

                if (typeof products == 'object') {
                    let prod
                    if (Array.isArray(products) && products.length > 0) {
                        prod = products[0]; // pierwszy z rozmiarów
                    } else {
                        prod = products;
                    }


                    let prodName = prod.Id.replaceAll('_', ' ');
                    let href = window.baseUrl + '/produkt/' + prod.Www.Kotwica;
                    let item = jQuery('<a href="' + href + '" class="tile col"></a>');
                    if ((typeof prod.Zdjęcia == 'object' && prod.Zdjęcia.length > 0)) {
                        // let prodThumb =  prod.Zdjęcia[0].Ścieżka;
                        let carousel = jQuery('<div id="productCarousel' + prod.Ean + '" class="carousel slide"/>');
                        let carouselInner = jQuery('<div class="carousel-inner"/>');
                        let indicators = jQuery('<div class="carousel-indicators"/>');
                        for (let i in prod.Zdjęcia) {
                            let prodThumb = prod.Zdjęcia[i].Ścieżka;
                            let carouselItem = jQuery('<div class="carousel-item' + (i == 0 ? ' active' : '') + '"><img src="https://www.lustra.pl/' + prod.Www.Ścieżka + '/' + prodThumb + '.mini250.webp" alt="" width="210" height="297" loading="lazy"></div>');
                            carouselInner.append(carouselItem);
                            // item.append(thumb);
                            let button = jQuery('<button type="button"/>');
                            button.attr('data-bs-target', '#productCarousel' + prod.Ean);
                            button.attr('data-bs-slide-to', i);
                            button.on('mouseover', function () {
                                jQuery(this).trigger('click');
                            });
                            if (i == 0) {
                                button.attr('aria-current', true);
                                button.addClass('active');
                            }
                            indicators.append(button);
                        }
                        carousel.append(carouselInner);
                        carousel.append(indicators);
                        item.append(carousel);
                        new bootstrap.Carousel(carousel, {
                            interval: false,
                            ride: false,
                            touch: true
                        });
                    }

                    let title = jQuery('<div class="tile-title">' + prodName + '</div>');
                    item.append(title);

                    if (typeof prod.Opis != 'undefined') {
                        let desc = jQuery('<div class="tile-text flex-fill">' + prod.Opis + '</div>');
                        item.append(desc);
                    }

                    // let btn = jQuery('<div class="tile-overlay"><button class="btn btn-outline-light">zobacz więcej</button></div>');
                    // item.append(btn);
                    if (typeof prod.Wymiar != 'undefined' && products.length > 1) {
                        let ul = jQuery('<ul class="dropdown-menu rozmiary-produktu"></ul>');
                        let rozmiary = sortujRozmiary(products);
                        for (let r in rozmiary) {
                            let rProd = rozmiary[r];
                            let href = window.baseUrl + '/produkt/' + rProd.Www.Kotwica;
                            let li = jQuery('<li><a href="' + href + '" class="dropdown-item">' + rProd.Wymiar.Szer / 10 + '×' + rProd.Wymiar.Wyso / 10 + '</a></li>');
                            ul.append(li);
                        }
                        let btn = jQuery('<button class="btn btn-outline-primary dropdown-toggle" type="button"data-bs-toggle="dropdown" aria-expanded="false" style="text-transform: lowercase">dostępne różne wymiary</button>')
                        let droprownRozmiary = jQuery('<div class="dropdown"></div>').append(btn).append(ul);
                        item.append(droprownRozmiary);
                    }

                    jQuery('#' + elementID + ' .products-list:first').append(item);
                }


            }
        } else {
            jQuery('#' + elementID).hide();
        }
    }

    let renderWariantyProduktu = function () {
        if (window.wariantyProduktu.length > 0) {
            for (let i in window.wariantyProduktu) {
                let prod = window.wariantyProduktu[i];
                let tr = jQuery('<tr/>');
                let td = jQuery('<td/>');
                td.append('<a href="' + prod.Www.Kotwica + '">' + prod.Id.toString().replaceAll('_', ' ') + '</a>');
                tr.append(td);
                tr.append('<td>' + prod.Ean + '</td>');
                if (typeof prod.Wymiar != 'undefined') {
                    tr.append('<td>' + prod.Wymiar.Szer + '×' + prod.Wymiar.Wyso + ' mm</td>');
                } else {
                    tr.append('<td/>');
                }
                if (typeof prod.Wymiar != 'undefined' && typeof prod.Wymiar.Grub != 'undefined') {
                    tr.append('<td>' + prod.Wymiar.Grub + ' mm</td>');
                } else {
                    tr.append('<td/>');
                }
                if (typeof prod.Kształt != 'undefined') {
                    tr.append('<td>' + prod.Kształt + '</td>');
                } else {
                    tr.append('<td/>');
                }
                jQuery('#warianty tbody').append(tr);
            }
        } else {
            jQuery('#sectionVariants').remove();
        }
    }

    let renderRozmiaryProduktu = function () {
        for (let r in window.kartaProduktu.rozmiary) {
            let rProd = window.kartaProduktu.rozmiary[r];
            let li = jQuery('<li/>');
            let href = window.baseUrl + '/produkt/' + rProd.Www.Kotwica;
            li.append('<a href="' + href + '" class="dropdown-item">' + rProd.Wymiar.Szer / 10 + '×' + rProd.Wymiar.Wyso / 10 + ' cm</a>');
            jQuery('#rozmiaryProduktu').append(li);
        }
    }


    jQuery('#main-loader').hide();

    // RENDEROWANIE PRODUKTÓW W KATEGORII
    if (typeof window.categoryProductsData != 'undefined') {
        renderProductsList(window.categoryProductsData, 'sectionCategoryProducts');
    } else {
        jQuery('#sectionCategoryProducts').remove();
    }

    // RENDEROWANIE NOWYCH PRODUKTÓW
    const newProductsSection = document.getElementById('sectionNewProducts');

    if (newProductsSection && typeof window.newProductsData !== 'undefined') {
        // Create intersection observer
        const observer = new IntersectionObserver((entries, observer) => {
            // Loop through the entries
            entries.forEach(entry => {
                // If the element is in view
                if (entry.isIntersecting) {
                    // Render products
                    renderProductsList(window.newProductsData, 'sectionNewProducts');
                    // Stop observing after rendering
                    observer.unobserve(entry.target);
                }
            });
        }, {

            rootMargin: '0px 0px 300px 0px',
            threshold: 0.1

        });

        // Start observing the section
        observer.observe(newProductsSection);
    } else if (typeof window.newProductsData === 'undefined') {
        // If no data is available, remove the section
        jQuery('#sectionNewProducts').remove();
    }

    // RENDEROWANIE WARIANTÓW
    if (typeof window.wariantyProduktu != 'undefined') {
        renderWariantyProduktu();
    }

    // RENDEROWANIE ROZMIARÓW W LIŚCIE
    if (typeof window.kartaProduktu != 'undefined') {
        renderRozmiaryProduktu();
    }
};

jQuery(window).resize(function () {
    mainResize();
});

jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() >= 67) {
        if (!topNavbar.hasClass('fixed-top')) {
            topNavbar.addClass('fixed-top');
            body.addClass('fixed-navbar');
        }
    } else {
        topNavbar.removeClass('fixed-top');
        body.removeClass('fixed-navbar');
    }
});

/* CONTACT FORMS
window.recaptchaCurrentForm=null;
window.onRecaptchaSuccess = function(token) {
    let form = window.recaptchaCurrentForm;
    window.submitForm(token, form);
};

grecaptcha.ready(function() {
    jQuery(".recaptcha-submit").each(function() {
        jQuery(this).on("click", function(event) {
            let form = jQuery(this).closest('form');
            window.recaptchaCurrentForm = form[0];
            form = window.recaptchaCurrentForm;
            if (!form.checkValidity()) {
                // invalid
                event.preventDefault();
                event.stopPropagation();
                form.classList.remove('valid');
                form.classList.add('invalid');
            } else {
                // valid
                form.classList.remove('invalid');
                form.classList.add('valid');
                if(form.classList.contains('send-ajax')) {
                    event.preventDefault();
                    event.stopPropagation();
                    grecaptcha.execute();
                }
            }
            form.classList.add('was-validated');
        });
    });
});

window.submitForm = function (token, form) {
    let formAlertModal = new window.bootstrap.Modal(document.getElementById('formAlertModal'), {
        keyboard: false
    });
    let formUrl = form.getAttribute('action');
    let formElements = form.elements;
    let formData = {
        '_token': jQuery('meta[name="csrf-token"]').attr('content')
    }
    for (let i = 0; i < formElements.length; i++) {
        if (['TEXTAREA', 'INPUT', 'SELECT'].indexOf(formElements[i].nodeName) > -1) {
            formData[formElements[i].name] = formElements[i].value;
        }
    }
    jQuery.post(formUrl, formData, function (response) {
        if (response.success) {
            // ok
            form.reset();
            form.classList.remove('was-validated');
            document.getElementById('formAlertModalBody').innerHTML = '<div class="alert alert-success">' + response.message + '</div>';
            formAlertModal.show();
        } else {
            // invalid
            document.getElementById('formAlertModalBody').innerHTML = '<div class="alert alert-danger">' + response.message + '</div>';
            formAlertModal.show();
        }
    }, 'json').fail(function () {
        document.getElementById('formAlertModalBody').innerHTML = '<div class="alert alert-danger">Wystąpił nieoczekiwany problem, spróbuj ponownie później.</div>';
        formAlertModal.show();
    });
}
 CONTACT FORMS END */
var recaptcha1, recaptcha2;
window.recaptchaCallbackForm = null;
window.onRecaptchaLoadCallback = function () {
    if (jQuery('#popup_recaptcha').length > 0) {
        recaptcha1 = grecaptcha.render('popup_recaptcha', {
            'sitekey': window.recaptchaKey,
        });
    }
    if (jQuery('#form_recaptcha').length > 0) {
        recaptcha2 = grecaptcha.render('form_recaptcha', {
            'sitekey': window.recaptchaKey
        });
    }
}
window.onRecaptchaCallback = function () {
    let captchaErr = jQuery(window.recaptchaCallbackForm).find('.error-captcha');
    captchaErr.empty();
};
window.onRecaptchaError = function () {
    let captchaErr = jQuery(window.recaptchaCallbackForm).find('.error-captcha');
    captchaErr.append('Zaznacz pole "Nie jestem robotem".');
};

(() => {
    'use strict';

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('.needs-validation');

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach((form) => {
        form.addEventListener('submit', (event) => {
            event.preventDefault();
            event.stopPropagation();
            window.recaptchaCallbackForm = form;

            let recaptchaId = recaptcha2;
            if (jQuery(form).attr('id') === 'popup_form') {
                recaptchaId = recaptcha1;
            }

            if (grecaptcha.getResponse(recaptchaId).length == 0) {
                let captchaErr = jQuery(form).find('.error-captcha');
                captchaErr.empty();
                captchaErr.append('Zaznacz pole "Nie jestem robotem".');
            }
            if (form.checkValidity()) {
                let formAlertModal = new window.bootstrap.Modal(document.getElementById('formAlertModal'), {
                    keyboard: false
                });
                let formUrl = form.getAttribute('action');
                let formElements = form.elements;
                let formData = {
                    '_token': jQuery('meta[name="csrf-token"]').attr('content')
                }
                let recaptcha = false;
                for (let i = 0; i < formElements.length; i++) {
                    if (['TEXTAREA', 'INPUT', 'SELECT'].indexOf(formElements[i].nodeName) > -1) {
                        formData[formElements[i].name] = formElements[i].value;
                        if (formElements[i].name == 'g-recaptcha-response' && formElements[i].value) {
                            recaptcha = true;
                        }
                    }
                }
                if (recaptcha) {
                    jQuery.post(formUrl, formData, function (response) {
                        if (response.success) {
                            // ok
                            form.reset();
                            form.classList.remove('was-validated');
                            document.getElementById('formAlertModalBody').innerHTML = '<div class="alert text-success text-center">' + response.message + '</div>';
                            formAlertModal.show();
                            if (response.gtm_event === true) {
                                dataLayer.push({'event': 'formsubmit'});
                            }
                        } else {
                            // invalid
                            document.getElementById('formAlertModalBody').innerHTML = '<div class="alert text-danger text-center">' + response.message + '</div>';
                            formAlertModal.show();
                        }
                    }, 'json').fail(function () {
                        document.getElementById('formAlertModalBody').innerHTML = '<div class="alert text-danger text-center">Wystąpił nieoczekiwany problem, spróbuj ponownie później.</div>';
                        formAlertModal.show();
                    });
                } else {
                    document.getElementById('formAlertModalBody').innerHTML = '<div class="alert text-danger text-center">Zaznacz pole: Nie jestem robotem.</div>';
                    formAlertModal.show();
                }
            }
            form.classList.add('was-validated');
            grecaptcha.reset(recaptchaId);
        }, false);
    });
})();


//Funkcje

function mainResize() {
    var wwidth = jQuery(window).width();
    if (wwidth <= 767) {
        placementObjectBefore(jQuery('.form-footer .form-check').first(), jQuery('.form-footer .cnt-btn'));
    } else {
        placementObjectAppend(jQuery('.form-footer .form-check').first(), jQuery('.form-footer .cnt-col'));
    }
}

function placementObjectBefore(element, elementBefore) {
    jQuery(elementBefore).before(jQuery(element));
}

function placementObjectAfter(element, elementAfter) {
    jQuery(elementAfter).after(jQuery(element));
}

function placementObjectAppend(element, elementAppend) {
    jQuery(elementAppend).append(jQuery(element));
}

function placementObjectPrepend(element, elementPrepend) {
    jQuery(elementPrepend).prepend(jQuery(element));
}

let lgGallery;

function createLightGallery(containerId) {
    let items = window.productPhotos;
    const $lgContainer = document.getElementById("inline-gallery-container");
    if ($lgContainer) {
        lgGallery = lightGallery($lgContainer, {
            plugins: [lgZoom, lgThumbnail],
            licenseKey: '5675B075-2A9A-4D68-A9C0-0C8919960BEC',
            speed: 250,
            zoom: true,
            // scale: 0.25,
            // scale: 0.25,
            // actualSize: true,
            // actualSizeIcons: { zoomIn: '', zoomOut: 'lg-zoom-out', },
            // infiniteZoom: true,
            showZoomInOutIcons: true,
            showMaximizeIcon: true, // Add maximize icon to enlarge the gallery
            container: $lgContainer,
            dynamic: true,
            hash: false,
            closable: false,
            dynamicEl: items,
            swipeThreshold: 10,
            enableSwipeEffectOnMove: false,
            // slideEndAnimation: false,
            // startAnimationDuration: 0,
            enableAnimateZoomMove: false

        });

        /*
            $lgContainer.addEventListener('lgAfterOpen', function (e) {
                // poniższe wyłączenie dblclick nie działa :/
                lgGallery.LGel.off('dblclick.lg'); // Wyłączenie dostępnej obsługi
                lgGallery.LGel.on('dblclick.lg', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    // Tutaj możesz podać własną funkcję
                    return;
                });
            });
        */

        $lgContainer.addEventListener('lgContainerResize', function (e) {
            const $lgOuter = $lgContainer.querySelector('.lg-outer');
            const actualSizeButton = document.getElementById('lg-actual-size-1'); // Znajduje przycisk "View actual size"
            if ($lgOuter.classList.contains('lg-zoomed') && actualSizeButton) {
                actualSizeButton.click(); // Wywołuje programowe kliknięcie
            }
            document.body.classList.toggle('no-scroll');
        });
        // lg-container lg-show lg-show-in lg-inline
        // lg-container lg-show lg-show-in
        const lgContent = $lgContainer.querySelector('.lg-content'); // Pobranie elementu .lg-content
        if (lgContent) {
            let isSwipe = false; // Flaga wskazująca czy nastąpiło przesunięcie palcem
            let touchStartX = 0; // Pozycja X przy dotknięciu
            let touchStartY = 0; // Pozycja Y przy dotknięciu
            let touchStartTime = 0; // Moment rozpoczęcia dotyku

            // Zdarzenie `touchstart` (początek dotknięcia)
            lgContent.addEventListener('touchstart', function (e) {
                const touch = e.touches[0]; // Pierwszy punkt dotknięcia
                touchStartX = touch.clientX; // Początkowa pozycja X
                touchStartY = touch.clientY; // Początkowa pozycja Y
                touchStartTime = Date.now(); // Ustaw czas startu
                isSwipe = false; // Reset flagi
            });

            // Zdarzenie `touchend` (koniec dotknięcia)
            lgContent.addEventListener('touchend', function (e) {
                const touch = e.changedTouches[0]; // Punkt zakończenia dotyku
                const touchEndX = touch.clientX; // Końcowa pozycja X
                const touchEndY = touch.clientY; // Końcowa pozycja Y
                const touchEndTime = Date.now(); // Czas zakończenia dotyku

                // Oblicz przesunięcie
                const diffX = Math.abs(touchEndX - touchStartX); // Różnica w X
                const diffY = Math.abs(touchEndY - touchStartY); // Różnica w Y
                const elapsedTime = touchEndTime - touchStartTime; // Czas trwania gestu

                // Swipe: jeśli przesunięcie jest większe niż próg lub czas gestu jest bardzo krótki (jak dla swipe)
                if ((diffX > 20 || diffY > 20) && elapsedTime < 500) {
                    isSwipe = true; // Ustaw flagę "swipe"
                }
            });

            let isDragging = false; // Flaga wskazująca czy nastąpiło przesunięcie myszką
            let mouseDownX = 0; // Pozycja X w momencie rozpoczęcia zdarzenia mousedown
            let mouseDownY = 0; // Pozycja Y w momencie rozpoczęcia zdarzenia mousedown

            // Obsługa kliknięcia `mousedown` (początek przytrzymania myszką)
            lgContent.addEventListener('mousedown', function (e) {
                mouseDownX = e.clientX; // Zapisz pozycję X myszy
                mouseDownY = e.clientY; // Zapisz pozycję Y myszy
                isDragging = false; // Resetuj flagę przesunięcia
            });
            // lgContent.addEventListener('mouseup', function (e) {
            //     isDragging = false;
            // });

            // Obsługa zdarzenia `mousemove` (ruch myszy)
            lgContent.addEventListener('mousemove', function (e) {
                const diffX = Math.abs(e.clientX - mouseDownX); // Różnica X
                const diffY = Math.abs(e.clientY - mouseDownY); // Różnica Y

                // Jeżeli różnica pozycji jest większa niż 10px, ustaw `isDragging`
                if (diffX > 10 || diffY > 10) {
                    isDragging = true; // Rozpoznano przesunięcie
                }
            });

            // Obsługa `click`
            lgContent.addEventListener('click', function (e) {
                const maximizeButton = document.getElementById("lg-maximize-1");
                if (e.target.classList.contains('lg-image')) {
                    if (isSwipe || isDragging) {
                        e.preventDefault(); // Zablokuj domyślną akcję, jeśli nastąpiło przesunięcie
                        return; // Wyjdź z obsługi click
                    }
                    if ($lgContainer) {
                        const firstChildDiv = $lgContainer.querySelector(':scope > div'); // Pobiera pierwszy bezpośredni element <div>
                        if (firstChildDiv && firstChildDiv.classList.contains('lg-inline')) {
                            // kliknięcie w zdjęcie w małej galerii
                            if (maximizeButton) {
                                maximizeButton.click(); // powiększenie galerii
                            }
                        } else {
                            // kliknięcie w zdjęcie w dużej galerii
                            const zoomInButton = document.getElementById('lg-zoom-in-1'); // Znajduje przycisk "View actual size"
                            if (zoomInButton) {
                                zoomInButton.click(); // zoom-in
                            }
                        }
                    }
                } else {
                    if (maximizeButton && !e.target.classList.contains('lg-icon')) {
                        maximizeButton.click(); // pomniejszenie galerii
                    }
                }
            });
        }
        setTimeout(() => {
            lgGallery.openGallery();
        }, 250);
    }
}

document.addEventListener('DOMContentLoaded', function () {
    createLightGallery('inline-gallery-container');
});

/**
 * Generate FAQ structured data from Bootstrap accordion
 * @param {string} accordionSelector - CSS selector for the accordion container
 * @returns {object} - Structured data object for FAQ
 */
function generateFAQStructuredData(accordionSelector = '#accordionFlushExample') {
    const accordion = document.querySelector(accordionSelector);
    if (!accordion) {
        console.warn('Accordion not found with selector:', accordionSelector);
        return null;
    }

    const faqItems = [];
    const accordionItems = accordion.querySelectorAll('.accordion-item');

    accordionItems.forEach(item => {
        const questionButton = item.querySelector('.accordion-button');
        const answerBody = item.querySelector('.accordion-body');

        if (questionButton && answerBody) {
            const question = questionButton.textContent.trim();
            const answer = answerBody.textContent.trim();

            faqItems.push({
                "@type": "Question",
                "name": question,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": answer
                }
            });
        }
    });

    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqItems
    };
}

/**
 * Inject structured data into the page
 * @param {string} accordionSelector - CSS selector for the accordion container
 */
function injectFAQStructuredData(accordionSelector = '#accordionFlushExample') {
    const structuredData = generateFAQStructuredData(accordionSelector);

    if (!structuredData) {
        return;
    }

    // Remove existing FAQ structured data if present
    const existingScript = document.querySelector('script[type="application/ld+json"][data-faq-structured-data]');
    if (existingScript) {
        existingScript.remove();
    }

    // Create and inject new structured data script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-faq-structured-data', 'true');
    script.textContent = JSON.stringify(structuredData, null, 2);

    document.head.appendChild(script);
}

/**
 * Initialize FAQ structured data when DOM is ready
 */
function initFAQStructuredData() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            injectFAQStructuredData();
        });
    } else {
        injectFAQStructuredData();
    }
}


initFAQStructuredData();